import { render, staticRenderFns } from "./blacklist-drawer.vue?vue&type=template&id=118b9308&"
import script from "./blacklist-drawer.vue?vue&type=script&lang=js&"
export * from "./blacklist-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports